export default __webpack_public_path__ + "static/media/toras.695dec24.jfif";